import { useXScale, useDrawingArea } from '@mui/x-charts-pro';
import { Box } from '@mui/material';
import { ArrowRight, Schedule } from '@mui/icons-material';
import { flagEmojiString } from '@/components/common/FlagsWithGeoAddr';
import { formatMsUTCToHM } from '@/utilities/timeUtils';
import { TachographBorderCrossings } from './TachographService';
import { TextBubbleMarker } from './TextBubbleMarker';

export function BorderCrossingsLayer({ borderCrossings }: { borderCrossings: TachographBorderCrossings[] }) {
  const { top, height } = useDrawingArea();
  const xScale = useXScale();

  return (
    <g pointerEvents="none" data-qa-element-id="border_crossing_layer">
      {borderCrossings.map((borderCrossing, index) => {
        const xHours = borderCrossing.timeInDayMillis / 3_600_000;
        const positionPx = xScale?.(xHours);
        if (!positionPx) {
          return null;
        }

        const fromFlag = flagEmojiString(borderCrossing.fromCountry.code);
        const toFlag = flagEmojiString(borderCrossing.toCountry.code);

        const pillWidth = 54;

        const tooltipTitle = (
          <Box style={{ display: 'flex', alignItems: 'center', fontSize: '10px !important' }}>
            <strong data-qa-element-id="tooltip_date">
              <Schedule sx={{ fontSize: '12px', marginBottom: '-2px', marginRight: '5px' }} />[
              {formatMsUTCToHM(borderCrossing.timeInDayMillis)}]
            </strong>
            <span style={{ marginLeft: '5px' }} data-qa-element-id="tooltip_from_flag">
              {fromFlag} {borderCrossing.fromCountry.name}
            </span>
            <ArrowRight sx={{ fontSize: '12px !important' }} />
            <span data-qa-element-id="tooltip_to_flag">
              {toFlag} {borderCrossing.toCountry.name}
            </span>
          </Box>
        );

        const contentTitle = (
          <Box
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <span data-qa-element-id="chart_from_flag">{fromFlag}</span>
            <ArrowRight color="action" sx={{ fontSize: '16px', marginBottom: '-2px' }} />
            <span data-qa-element-id="chart_to_flag">{toFlag}</span>
          </Box>
        );

        return (
          <TextBubbleMarker
            key={`BorderCrossing-BubbleMarker-${index}`}
            index={index}
            positionPx={positionPx}
            pillWidth={pillWidth}
            top={top - 22}
            bottom={top + height}
            contentTitle={contentTitle}
            tooltipTitle={tooltipTitle}
          />
        );
      })}
    </g>
  );
}
